module.exports = __webpack_public_path__ + "static/media/PDF_82.a78fd9a1.pdf";